import React from "react";
import { ProjectSettingsPage } from "@iventis/project-settings/src/project-settings";
import PageWithAppBar from "./page-with-appbar";

export default () => (
    <PageWithAppBar>
        <ProjectSettingsPage />
    </PageWithAppBar>
);
